import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { Hr_Race } from "@/graphql/gql/graphql";
import { getUpcomingHorseRaces } from "../api";
import { filterEmpty } from "..";

const useUpcomingRaces = () => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    placeholderData: keepPreviousData,
    refetchInterval: 30000,
    queryKey: ["upcoming horse races"],
    queryFn: (context) =>
      getUpcomingHorseRaces({ results: 5, current: context.pageParam }),
    getNextPageParam: (resp, pages, last) => {
      if (resp.HR_Races && resp.HR_Races.length > 0) {
        return last + 1;
      }
      return undefined;
    },
    initialPageParam: 0,
  });

  const races =
    data &&
    data.pages.reduce((raceList, page) => {
      if (page.HR_Races) {
        return [...raceList, ...filterEmpty(page.HR_Races)];
      }
      return raceList;
    }, [] as Hr_Race[]);

  return {
    races,
    fetchNextPage,
    hasNextPage,
    isError,
    isLoading,
    isFetching,
    isFetchingNextPage,
    refetch,
  };
};

export default useUpcomingRaces;
